import React from "react";
import { useTranslation } from "i18n";
import { FooterMini } from "component-library";

const ProfileMiniFooter = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="page-container flex pl-2 text-xs text-grey-shark-5">
        {t("performer:profile.footer.disclaimer")}
      </div>
      <FooterMini />
    </>
  );
};

export default ProfileMiniFooter;
